import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-requests-student-dialog',
  templateUrl: './requests-student-dialog.component.html',
  styleUrls: ['./requests-student-dialog.component.scss']
})
export class RequestsStudentDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<RequestsStudentDialogComponent>) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(0);
  }

}
